import { ReactElement } from 'react';
import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';

import './css/landing-page-unified.css';
import './js/nav-scroll';
import './js/script';

const Home = (): ReactElement => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  );
};

export default Home;
